const VALID_POSITIONS = ['Студент', 'Школьник', 'Прочее'];

export const checkProfileForWorkshop = (user, workshopYear = 2026) => {
  const requiredFields = [
    { field: 'first_name', name: 'имя' },
    { field: 'last_name', name: 'фамилию' },
    { field: 'email', name: 'email' },
  ];

  if (workshopYear >= 2026) {
    requiredFields.push(
      { field: 'address', name: 'город' },
      { field: 'workplace', name: 'место работы/учёбы' },
      { field: 'contact', name: 'контакты' },
      { field: 'phone_number', name: 'номер телефона' },
      { field: 'birth_date', name: 'дату рождения' }
    );
  }

  const missingFields = requiredFields
    .filter(({ field }) => {
      const value = user[field];
      return !value || value.toString().trim() === '';
    })
    .map(({ name }) => name);

  if (workshopYear >= 2026 && user.position && !VALID_POSITIONS.includes(user.position)) {
    return {
      isValid: false,
      missingFields: [],
      message: 'Для подачи заявки необходимо обновить информацию о себе в профиле: укажите вашу роль (Студент, Школьник или Прочее).'
    };
  }

  if (workshopYear >= 2026 && !user.position) {
    missingFields.push('роль (Студент / Школьник / Прочее)');
  }

  return {
    isValid: missingFields.length === 0,
    missingFields,
    message: missingFields.length > 0
      ? `Для подачи заявки необходимо заполнить профиль: укажите ${missingFields.join(', ')}.`
      : ''
  };
};
